import { action, thunk } from 'easy-peasy';
import updateItems from 'services/proposals/update-items';

export default {
	loading: false,
	setLoading: action((state, payload) => {
		state.loading = payload;
	}),
	loadingPromo: false,
	setLoadingPromo: action((state, payload) => {
		state.loadingPromo = payload;
	}),
	data: {},
	promotions: [],
	save: action((state, payload) => {
		state.data = payload;
		if (payload.kitItems && payload.kitItems.length > 0)
			state.data.kitItems = state.data.kitItems.map(item => ({
				...item,
				quantityOriginal: item.quantity,
				isSelected: false
			}));
		state.data.promoCode = state.data.promoCode ? state.data.promoCode : '_empty_';
	}),
	setPromotions: action((state, payload) => {
		const selectNew = [{ sapPromoId: '_empty_', name: 'Nessuna promo selezionata', isSelected: false }];
		const decoratedPromo = [...selectNew, ...payload];
		state.promotions = decoratedPromo.map((promo, index) => ({
			...promo,
			isSelected: state.data.promoCode ? promo.sapPromoId === state.data.promoCode : index === 0
		}));
	}),
	selectPromotion: action((state, payload) => {
		state.promotions = state.promotions.map(promo => ({
			...promo,
			isSelected: promo.sapPromoId === payload
		}));
		state.data.promoCode = state.promotions.find(item => item.isSelected).sapPromoId;
		state.data.promoDesc = state.promotions.find(item => item.isSelected).name;
	}),
	setName: action((state, payload) => {
		state.data.name = payload;
	}),
	setInternalCode: action((state, payload) => {
		state.data.internalCode = payload;
	}),
	setEnabled: action((state, payload) => {
		state.data.enabled = payload;
	}),
	setDateFrom: action((state, payload) => {
		state.data.dateFrom = payload;
	}),
	setDeliveryDate: action((state, payload) => {
		state.data.deliveryDate = payload;
	}),
	setAvailable: action((state, payload) => {
		state.data.available = payload;
	}),
	selectAll: action((state, payload) => {
		state.data.kitItems = state.data.kitItems.map(item => ({
			...item,
			isSelected: true
		}));
	}),
	deselectAll: action((state, payload) => {
		state.data.kitItems = state.data.kitItems.map(item => ({
			...item,
			isSelected: false
		}));
	}),
	toggleSelection: action((state, payload) => {
		state.data.kitItems = state.data.kitItems.map(item => ({
			...item,
			isSelected: item.id === payload ? !item.isSelected : item.isSelected
		}));
	}),
	setQuantityItem: action((state, payload) => {
		const { id, number } = payload;
		state.data.kitItems = state.data.kitItems.map(item => ({
			...item,
			quantity: item.id == id ? number : item.quantity,
			isSelected:
				item.id == id && number !== item.quantityOriginal
					? true
					: item.id == id && number === item.quantityOriginal
					? false
					: item.isSelected
		}));
	}),
	load: thunk((actions, payload, { injections, getStoreActions }) => {
		const { services } = injections;
		actions.setLoading(true);
		return services.kit
			.getDetails(payload)
			.then(data => {
				actions.save(data.item);
				return Promise.resolve(data);
			})
			.catch(e => {
				getStoreActions().error('kit.errorGetDetails');
			})
			.finally(_ => {
				actions.setLoading(false);
			});
	}),
	loadPromotions: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		const { services } = injections;
		actions.setLoadingPromo(true);
		return services.promotions
			.getWishlist()
			.then(data => {
				actions.setPromotions(data);
				return Promise.resolve(data);
			})
			.catch(e => {
				getStoreActions().error('kit.getPromotions');
			})
			.finally(_ => {
				actions.setLoadingPromo(false);
			});
	}),
	update: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		const { services } = injections;
		actions.setLoading(true);
		const kit = getStoreState().kit.detail.data;
		const infoKit = {
			kitId: kit.id,
			nome: kit.name,
			internalCode: kit.internalCode,
			promoCode: kit.promoCode !== '_empty_' ? kit.promoCode : null,
			promoDesc: kit.promoCode !== '_empty_' ? kit.promoDesc : null,
			enabled: kit.enabled,
			dateFrom: kit.dateFrom,
			deliveryDate: kit.deliveryDate,
			available: kit.available
		};
		return services.kit
			.update(infoKit)
			.then(data => {
				getStoreActions().success('kit.update');
			})
			.catch(e => {
				getStoreActions().error('kit.errorUpdate');
			})
			.finally(_ => {
				actions.setLoading(false);
			});
	}),
	deleteItems: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		const { services } = injections;
		actions.setLoading(true);
		const itmesDelete = getStoreState().kit.detail.data.kitItems.filter(item => item.isSelected);
		const updatingItems = {
			eansToInsert: [],
			eansToDelete: itmesDelete.map(item => ({ ean: item.catalog.ean, quantity: item.quantity }))
		};
		const kitId = getStoreState().kit.detail.data.id;
		return services.kit
			.updateItems(updatingItems, kitId)
			.then(_ => {
				getStoreActions().success('kit.articlesDeleted');
				getStoreActions().kit.detail.load(kitId);
			})
			.catch(_ => {
				getStoreActions().error('kit.errorDeletItems');
			})
			.finally(_ => {
				actions.setLoading(false);
			});
	}),
	updateItems: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		const { services } = injections;
		actions.setLoading(true);
		const itmesUpdate = getStoreState().kit.detail.data.kitItems.filter(
			item => item.quantityOriginal !== item.quantity
		);
		const updatingItems = {
			eansToInsert: itmesUpdate.map(item => ({ ean: item.catalog.ean, quantity: item.quantity })),
			eansToDelete: []
		};
		const kitId = getStoreState().kit.detail.data.id;
		return services.kit
			.updateItems(updatingItems, kitId)
			.then(_ => {
				getStoreActions().success('kit.update');
				getStoreActions().kit.detail.load(kitId);
			})
			.catch(_ => {
				getStoreActions().error('kit.errorUpdate');
			})
			.finally(_ => {
				actions.setLoading(false);
			});
	})
};
